import { Base64 } from 'js-base64'

export const tokenDecode = (token: string | null | undefined) => {
	if (!token || typeof token !== 'string') {
		return {}
	}
	try {
		return JSON.parse(Base64.decode(token.split('.')[1]))
	} catch {
		return {}
	}
}
